import type { EndpointConfig } from '../types'

// OAuth endpoint constants
export const OAuthEndpoints = {
  // User endpoints
  USER_INTROSPECT: 'user-introspect',
  USER_PROFILE: 'user-profile',

  // Authentication endpoints
  AUTH_LOGIN: 'auth-login',
  AUTH_LOGOUT: 'auth-logout',
  AUTH_REFRESH_TOKEN: 'auth-refresh-token',

  // Registration endpoints
  REGISTER_USER: 'register-user',
  VERIFY_EMAIL: 'verify-email',

  // Password management
  RESET_PASSWORD_REQUEST: 'reset-password-request',
  RESET_PASSWORD_CONFIRM: 'reset-password-confirm'
} as const

type EndpointKey = keyof typeof OAuthEndpoints
type EndpointId = (typeof OAuthEndpoints)[EndpointKey]

// OAuth endpoint configuration
export const oauthEndpointsConfig: Record<EndpointId, EndpointConfig> = {
  // User endpoints
  'user-introspect': {
    method: 'GET',
    path: '/api/v3/users/introspect',
    description: 'Get detailed user profile'
  },
  'user-profile': {
    method: 'GET',
    path: '/api/v3/users/profile',
    description: 'Get detailed user profile'
  },

  // Authentication endpoints
  'auth-login': {
    method: 'POST',
    path: '/api/v3/auth/login',
    description: 'Authenticate user and get access token'
  },
  'auth-logout': {
    method: 'POST',
    path: '/api/v3/auth/logout',
    description: 'Logout user and invalidate token'
  },
  'auth-refresh-token': {
    method: 'POST',
    path: '/api/v3/auth/refresh',
    description: 'Refresh access token using refresh token'
  },

  // Registration endpoints
  'register-user': {
    method: 'POST',
    path: '/api/v3/users/register',
    description: 'Register a new user'
  },
  'verify-email': {
    method: 'GET',
    path: '/api/v3/users/verify/:token',
    description: 'Verify user email with token'
  },

  // Password management
  'reset-password-request': {
    method: 'POST',
    path: '/api/v3/users/reset-password',
    description: 'Request password reset email'
  },
  'reset-password-confirm': {
    method: 'POST',
    path: '/api/v3/users/reset-password/:token',
    description: 'Confirm password reset with token'
  }
}
